<template>

    <button type="button" class="btn " :class="className" :onclick="onclick" v-html="title"></button>

</template>

<script>
export default {
  name: 'Button',
  props: {
    className: {
      type: String,
      default: 'btn-primary'
    },
    onclick: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
